export default {
  locale_name: '漢語',

  facebook: '脸熟',
  twitter: '推特',
  insta: '照片墙',
  telegram: '电报',
  buy: '购买',
  sell: '销售',
  login: '登录',
  sign_up: '会员加入',
  profile: '我的頁面',
  logout: '退出',
  home: '主页',
  asset: '资产',
  code: '代码',
  buy_btn: '购买',
  sell_btn: '销售',
  not_allow: '殘',
  trade: '交易',
  select: '选择',
  cancel: '取消',
  deposit: '入金',
  withdraw: '出金',
  request: '申请',
  account: '账号',
  status: '状态',
  allow: '允許',
  disallowed: '不允許的',
  modify: '修正',
  auto: '(自动输入)',
  inquiry: '查询',
  no_select: '(請輸入新的電子郵件)',
  confirm: '確認',
  upload_btn: '請放下或單擊此處。',
  continue_entry: '請在下面輸入 "[+:verification]" 以繼續',
  toasted_msg: {
    confirm: '已确认',
    changed: '已变更',
    withdrwal: '已注销',
    register: '已登录.',
    title: '通知',
    exchange: '直接兑换成功.',
    search: '已查询.',
    deposit_request: '已申请入金.',
    withdraw_request: '已申请出金.',
    create_account: '已创立账户.',
    modify: '已修正.',
    cancel: '已取消',
    trade_confirm: '已确定交易.',
    trade_reject: '已拒绝交易.',
    copy: '複製。',
    nice_msg: '如果您的浏览器配置不允许弹窗，则无法正常进行身份验证.',
    nice_title: '介绍',
    nice_error: '本人认证失败.',
    no_transfer: '沒有交流信息。',
    email_auth: '電子郵件驗證成功完成',
    email_auth_send: '驗證電子郵件已發送',
    kyc_withdraw: '帳戶驗證成功',
    not_allow_trade: '交易無效',
  },
  header: {
    C2C_enroll: 'C2C 登录',
    direct_buy: '即时购买',
    direct_sell: '即时销售',
    wallet_manage: '钱包管理',
    C2C_list: 'C2C清单',
    B2C_list: 'B2C清单',
    withdrawal: '入/出金',
    trade_list: '交易記錄',
    customer_service: '客户服务中心',
  },
  home_msg: {
    about_title: 'ABOUT RMT',
    about_title_2: 'RMT加入了韓國區塊鏈行業的發展。',
    about_line_1_1:
      '这是一个将虚拟货币以实物交换, 及中转站形态的新概念虚拟货币中转站',
    about_line_1_2: '严格挑选经过检验的数字货币后,进行上币',
    about_line_1_3: '一个支持多种语言的全球数字货币中转站。',
    about_line_2_1:
      '以大规模去中心化体系结构（Architecture）设计和DDOS攻击防御系统为基础 令人安心的安全性',
    about_line_2_2: '提供稳定的交易环境及资产补充管理的解决方案',
    about_line_3_1: '通过自身网络确保支付和交易的稳定性',
    about_line_3_2: '与客户建立互信关系并进行周期性服务更新。',
    about_line_4_1:
      '是一个不受网络限制，线上线下都可以活用加密资产的统合加密（crypto）平台。',
    about_sub_1: '核心',
    about_sub_1_1:
      '根据为了顺应全球监管趋势的FATF (Financial Action Task Forc)和虚拟资产服务提供机关(VASP: virtual Asset Service Providers)的建议书 RMT将遵守有关防止洗钱和反恐的规定',
    about_sub_1_2:
      '数字货币持有者的场外交易(OTC)的比重正在增加，并且随着交易所的可信度的下降，将支援C2C B2C等立即交易项目。',
    about_sub_2: '多样化的内容',
    about_sub_2_1: '使用自助服务机来提高随时随地离线访问的可靠性',
    about_sub_2_2: '制造卡式钱包，能最大化的确保安全性和便利性。',
    about_sub_2_3: '运营全球开放商城',
    about_sub_3: '全球蓝图',
    about_sub_3_1: '从韩国开始，将会向中国，东南亚，日本、欧洲服务扩散',
    about_sub_3_2:
      '将自助服务机引入到越南，菲律宾等海外国家 主导新时代的全球数字货币中介站-- RMT',
    about_side_1: '世界领先数字货币交易所',
    about_side_1_1: '可快速安全直接交易的(C2C) 24小时交易服务',
    about_side_1_2: '以安全系统为服务，提供数字货币系统的安全性',
    about_side_1_3: '提供无中间步骤的利用RMT进行快速(Quick)交易的B2C',
    about_side_1_4:
      '减少了OTC(场外交易)的麻烦和手续费负担，提供24小时离线、安全、便捷的直接交易服务。',
    login_register: '登錄/註冊',
    trade_guide: '查看交易指南',
    app_down_1: '應用下載',
    app_down_2: '各種硬幣，實時報價，輕鬆交易',
    app_down_3: '隨時隨地的便捷交易服務',
  },

  footer: {
    about: '介绍',
    career: '历史',
    escrow: 'escrow交易',
    press: '新闻舆论',
    partner: '如果想与我们成为合作伙伴的话',
    help: '顾客支援',
    chat: '客服',
    blog: '博客',
    phone: '联络方式',
    social: '社交',
  },
  footer_link: {
    about_title: '公司介绍 ',
    msg_about_1:
      'RMT是Real Money Trade的缩写，是一个虚拟货币中转站。根据为了顺应全球监管趋势的FATF (Financial Action Task Forc)和虚拟资产服务提供机关(VASP: virtual Asset Service Providers)的建议书，RMT将遵守有关防止洗钱和反恐的规定，将会给用户提供一个想要的，安全的交易环境。',
    msg_about_2:
      '数字货币持有者的场外交易(OTC)的比重正在增加，并且交易所的可信度正在下降，将支援C2C B2C等立即交易项目。为了顺应时代需求，RMT将支持C2C B2C等即时交易服务。',
    msg_about_3:
      'RMT 的ONE CARD将结合 Cold wallet 系统，保管被网络屏蔽的硬件装置中的虚拟货币，并在离线时进行处理，因此安全性非常高。',
    msg_about_4: 'ONE CARD不仅可以用于自动服务设备，也可以用于离线RMT中转站。',
    msg_about_5:
      '而且自助服务机器可以提供取款和存款，电影票购买，RMT购物中心等多样化服务。',
    msg_about_6:
      'RMT支持英语、中文、日语等多种语言，不仅在国内，还在海外普及自主服务机器，顺应电子金融的时代潮流。',
    escrow_big_title: 'escrow交易',
    msg_escrow_1:
      'escrow服务是指保障卖方和买方之间的交易安全，实现用户想要的资产保护服务。',
    msg_escrow_2: '-交易程序-',
    msg_escrow_3: '1. 只要会员充值KRW，就会将KRW存放在PG公司里保管。',
    msg_escrow_4:
      '2. 如果充完KRW的会员要求购买时，即可以把PG公司保管的资金向卖方支付汇款。',
    msg_escrow_5: '3. 卖方确认了钱，买方确认了coin就能成交。',
    msg_escrow_6: '4. 出现问题时，根据双方提供的证据为根据予以解决。',
    msg_escrow_7: 'RMT致力於保護您的資產。',
  },
  account_form: {
    id_place: '请输入ID',
    pw_place: '请输入密码',
    forgot_pw: '忘记密码',
    confirm_pw: '确认密码',
    name_place: '输入名字',
    email_place: '输入邮件',
    agree: '我同意',
    all_agree: '我同意所有人。',
    find_pw: '找回密码',
    code_place: '请输入验证码',
  },
  trade_page: {
    b2c_trade: 'B2C 交易',
    select_asset: '请选择资产',
    select_coin: '请选择币种',
    c2c_trade: 'C2C 交易',
    buy_asset: '将购买的资产',
    sell_asset: '出售資產',
    purchaser_name: '购买者名字',
    seller_name: '销售者名字',
    amount: '数量',
    limit_buy: '最低購買數量',
    limit_sell: '最低銷售量',
    total_sell_price: '總銷售數量',
    buy_price: '购买价格',
    sell_price: '销售价格',
    regdate: '最终信息修改日期',
    sell_register: '销售登录',
    buy_register: '购买登录',
    select_c2c_info: '选择卖出公告信息',
    seller_info: '销售者信息',
    market_select: '选择市场',
    market_title: 'market名字',
    sell_price_msg: '销售数量 (0.00000000)',
    min_sell_amount: '最少销售数量 ',
    min_buy_price: '最少购入数量',
    min_sell_amount_msg: '对方的最少购买数量 ',
    per_sell_price: '单价',
    per_sell_price_msg: '确定1.000000个的价格',
    per_sell_price_msg2: '请确定销售的单价.',
    select_account: '选择要接收的账户',
    withdraw_account: '選擇一個提款賬戶',
    direct_buy_asset: '即时购入的资产',
    change_target_asset: '交换对象资产',
    source_buy_asset: '购入资产',
    source_sell_asset: '销售资产',
    target_change_asset: '交换资产',
    buy_amount: '购入数量',
    buy_amount_msg: '预购数量 0.00000000',
    per_price: '单价',
    per_price_msg: '持有 {0} :',
    per_prcie_msg2: '自动定价.',
    receive_quantity: '数量数量',
    b2c_buy_title: '购买.',
    b2c_asset: '零变成一',
    b2c_market_price: '现在行情',
    b2c_direct_buy: '即时购买时',
    b2c_direct_sell: '即时销售时',
    b2c_exchange_amount: '兑换数量',
    b2c_amount: '适用数量',
    b2c_buy: '{0}购买',
    b2c_sell: '{0}销售',
    direct_sell_asset: '立即出售的資產',
    b2c_buy_price: '購買價',
    b2c_sell_price: '售價',
    b2c_sell_title: '出售。',
    sell_amount: '出售數量',
    bill_amount: '支付數量',
    potential_amount: '可用数量',
    holding_amount: '未确定销售数量',
    confirm_amount: '确定销售数量',
  },
  page_navigation: {
    first_page: '第一页',
    last_page: '最后一页',
  },
  wallet: {
    asset_value: '持有的资产',
    show_currency: '所有资产',
    asset_list: '资产目录',
    wallet_list: '账户目录',
    account_name: '账户名称',
    account_number: '账户号码',
    balance: '余额',
    withdrawal_register: '入/出金 申请',
    withdrawal_inquiry: '入/出金 申请 查询',
    account_register: '创建账户',
    deposit_inquiry: '入金查询',
    withdraw_inquiry: '出金查询',
    account_modify: '修改账户',
    deposit_price: '入金金额',
    deposit_register: '入金申请',
    withdraw_register: '出金申请',
    withdraw_price: '出金金额',
    account_seq: '账户固有号码',
    regdate: '开设日',
    hold_balance: '静止金额',
    selected_asset: '选择资产',
    before_regdate: '(开设前)',
    open: '开设',
    address_title: '賬戶地址信息',
    account_address: '帳號地址',
    create_account_address: '開戶地址',
    deposit_msg: '從外部錢包將{0}存入我的{0}錢包。',
    deposit_msg_1:
      '在區塊鏈上進行350次批准（確認）後，它將反映在{0}交易錢包中。',
    deposit_step_1: '步驟1.請首先檢查{0}備忘錄ID。',
    deposit_step_1_1: '我的{0}筆記ID',
    deposit_step_1_2:
      '存入{0}時，必須包括您的唯一便箋ID。沒有註釋ID發送的{0}將丟失。',
    deposit_step_1_3: '我確認了查看我的{0}錢包地址',
    deposit_step_1_btn: '產生筆記編號',
    deposit_step_2: '步驟2.請檢查我的錢包地址。',
    deposit_step_2_1: '二維碼',
    deposit_step_2_2: '錢包地址',
    deposit_step_2_3:
      '最低存款金額為<span style =“ color：＃4a90e2”> {0} {1} </ span>。',
    deposit_step_2_btn: '複製錢包地址',
    deposit_msg_2: '請確認',
    deposit_msg_2_1: '上面的地址僅用於存款。',
    deposit_msg_2_2:
      '完成確認的總時間可能會受到區塊鍊網絡擁塞的影響，並且加密貨幣造成的區塊鏈擁塞是<span style =“ color：＃4a90e2; cursor：指針;”>此處</ span>您可以檢查。',
  },
  private: {
    my_deal_list: '我的銷售清單',
    my_app_list: '我的購買清單',
    source_asset: '我的资产',
    target_asset: '别人的资产',
    source_amount: '我的资产数量',
    regdate: '公示日',
    source_max_amount: '最大数量',
    source_min_amount: '最小数量',
    max_price: '最大成交限制',
    min_price: '最小成交限制',
    close_date: '终结日',
    app_inquiry_cancel: '买入明细查询/取消',
    app_name: '买入者名字',
    per_price: '数量单价',
    confirm_reject: '确定/拒绝',
    fee_amount: '手续费合计',
    request_cancel: '取消申请',
    b2c_source_asset: '标准资产',
    b2c_target_asset: '对方资产',
    b2c_source_amount: '标准资产数量',
    b2c_target_amount: '对方资产数量',
    confirm: '確認',
    reject: '被拒絕',
    basic_rate: '適用交易標準費率',
    spread_rate: '應用點差率',
    exchange_rate: '適用匯率',
    source_account: '參考資產帳號',
    target_account: '相對資產帳號',
    fee_rate: '手續費',
    fee_calc: '减去{0}个',
    b2c_buy_asset: '購買資產',
    b2c_sell_asset: '銷售資產',
    b2c_buy_amount: '購買資產數量',
    b2c_sell_amount: '銷售資產數量',
    b2c_last_buy_amount: '最終購買價',
    b2c_last_sell_amount: '最終售價',
  },
  withdrawal: {
    deposit_list: '入金申请明细',
    withdraw_list: '出金申请明细',
    asset_name: '资产名',
    request_price: '邀请金额',
    deposit_inquiry_cancel: '查询/取消汇款明细',
    withdraw_inquiry_cancel: '查询/取消存取款明细',
    history_detail: '明细',
    regdate: '申请日',
  },
  myprofile: {
    profie: '会员信息',
    user_name: '会员名',
    email: '邮箱',
    regdate: '加入日期',
    last_login: '最近登录',
    kyc_cert: 'KYC 认证',
    kyc_cert_request: '认证申请',
    kyc_cert_list: '申请明细',
    pw_modify: '修改密码',
    email_modify: '修改邮箱',
    withdrawal: '退出账户',
    modal_msg: '如果您需要注销的话，请输入密码',
    old_pw: '請輸入您的舊密碼',
    new_pw: '請輸入新密碼',
    new_email: '請輸入新的電子郵件',
    authority: '本人认证',
    complete_auth: '认证完成',
    authenticate: '认证',
    uid: '成員ID（UID）',
    email_auth: '電子郵件身份驗證',
    auth: '身份驗證',
    auth_code_send: '發送驗證碼',
    auth_code: '驗證碼',
    auth_code_msg: '請在5分鐘內輸入您的驗證碼',
    otp_auth: ' OTP身份驗證',
    enroll: '報名',
    security: '安全級別',
    security_view: '查看安全級別',
    withdraw_auth: '提款地址認證',
  },
  kyc: {
    kyc_title: 'KYC认证',
    regdate: '登录日期',
    expdate: '到期日',
    detail: '详细',
    type_title: '類型名稱',
    withdraw_auth: '驗證取款地址',
    select_asset: '選擇資產',
    select_bank: '選擇銀行',
    holder_name: '持有人的姓名',
    出生: '出生的6位數字',
    地址: '資產地址',
    withdraw_list: '提款帳戶申請',
    bank_name: '銀行名稱',
    withdraw_info: '提款賬戶信息',
    withdraw_complete: '該資產已被認證。',
  },
  otp: {
    enter_verification_number: '輸入您的OTP驗證碼',
    otp_management: ' OTP管理',
    authenticode: ' OTP密鑰',
    otp_deactivate: '停用OTP',
    msg_authenticator_installation:
      '請在智能手機或台式機上安裝 "Google Authenticator" 應用',
    android: ' android',
    or: '或',
    iphone_series: ' iPhone，iPad和iPod',
    windows_phone: ' Windows Phone',
    and: '和',
    msg_microsoft_other_systems: '其他系統，包括Microsoft Windows桌面',
    msg_key: '此密鑰',
    msg_use_loss_change: '寫在紙上。當您丟失設備或需要更改OTP時使用。',
    msg_brcode_touch:
      '啟動“ Google Authenticator”應用，然後點擊屏幕底部的<b>掃描QR條碼</ b>。',
    msg_input_authenticode:
      '請在下面的 "身份驗證代碼" 字段中輸入顯示在屏幕上的身份驗證代碼。',
    otp_key: 'OTP密鑰',
    otp_activate: ' OTP激活',
    otp_copy: '已復制OTP密鑰',
    otp_safe_keeping: '您是否將OTP密鑰寫在紙上並將其存儲在安全的地方？',
    yes: '是',
    otp_register: '註冊',
    otp_register_success: ' OTP註冊成功完成',
    otp_delete_success: ' OTP擦除註冊成功完成。',
    msg_click_key_copy: '單擊以復制密鑰',
    otp_login: ' OTP登錄',
  },
  security: {
    security_auth: '安全認證',
    grade: '等級',
    condition: '條件',
    restriction: '限制',
    no_grade: '未分級',
    no: '無',
    security_title: '安全級別條件的限制',
  },
  notice_modal: {
    title: '注意事項',
    content:
      '這是一種重視客戶資產的RMT。 為了確保交易穩定，我們只會先進行註冊，然後通過以後的通知將交易開始日期通知客戶。',
    check: '一天沒見',
  },
}
